module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "mx-auto elevation-0"
  }, [_c('v-list', {
    attrs: {
      "dense": "dense"
    }
  }, [_c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-700 font-size-16"
  }, [_vm._v(_vm._s(_vm.datos.nombreArticulo))]), _c('v-list-item-subtitle', {
    staticClass: "font-size-12"
  }, [_vm._v(_vm._s(_vm.datos.codigoArticulo) + " - " + _vm._s(_vm.datos.modelo) + " - " + _vm._s(_vm.datos.linea))])], 1)], 1)], 1), _c('v-divider', {
    staticClass: "mx-4"
  }), _c('v-card-text', [_c('v-list', {
    attrs: {
      "dense": "dense"
    }
  }, [(_vm.showImageMarca) ? _c('v-list-item', {
    staticClass: "py-1"
  }, [_c('v-list-item-content', [_c('v-img', {
    attrs: {
      "src": (_vm.apiUpload + "/upload/octopus/marcas/" + (_vm.datos.marca) + ".jpg"),
      "width": "90",
      "height": "90",
      "contain": "contain"
    }
  })], 1)], 1) : _vm._e(), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("circle")])], 1), _c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v("Codigo nuevo articulo")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.datos.codigoArticuloNuevo
    }
  }, [_vm._v(_vm._s(_vm.datos.codigoArticuloNuevo ? _vm.datos.codigoArticuloNuevo : 'No se cuenta con codigo nuevo'))])], 1)], 1), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("business")])], 1), _c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v("Cliente")]), _c('v-list-item-title', {
    staticClass: "font-weight-700"
  }, [_vm._v(_vm._s(_vm.datos.nombreCliente) + " - " + _vm._s(_vm.datos.codigoClienteSap))])], 1)], 1), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("place")])], 1), _c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v("Direccion")]), _c('v-list-item-title', {
    staticClass: "font-weight-700"
  }, [_vm._v(_vm._s(_vm.datos.direccion) + " -  " + _vm._s(_vm.datos.codigoPostal))])], 1)], 1), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("description")])], 1), _c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v(" Fatura electronica")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.datos.factura
    }
  }, [_vm._v(_vm._s(_vm.datos.factura ? _vm.datos.factura : 'No se encontró ninguna factura o boleta'))])], 1)], 1), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("event_available")])], 1), _c('v-list-item-content', [_c('v-list-item-subtitle', [_vm._v(" Fecha de venta")]), _c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: {
      'error--text': !_vm.datos.fechaVenta
    }
  }, [_vm._v(_vm._s(_vm.datos.fechaVenta ? _vm.datos.fechaVenta : 'No se especifico'))])], 1)], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "pa-4"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "small",
      "block": "block"
    },
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Cerrar ventana")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e6310b2","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_card_informacion_serie.vue
// module id = 521
// module chunks = 1